import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { CloudOfflineIconComponent } from '@itero/ui-toolkit-angular/icons';

@Component({
	selector: 'rx-banner',
	templateUrl: './rx-banner.component.html',
	styleUrls: ['./rx-banner.component.scss'],
	standalone: true,
	imports: [CommonModule, CloudOfflineIconComponent]
})
export class RxBannerComponent {
	/** Classic RX uses `default` (light blue info). Intuitive RX uses neutral grays on the gray canvas. */
	@Input() appearance: 'default' | 'intuitive' = 'default';

	@Input() type: 'notification' | 'info';
	@Input() message: string | null;
	@Input() title: string;
	@Input() showOfflineIcon = false;

	get isIntuitiveAppearance(): boolean {
		return this.appearance === 'intuitive';
	}

	get isRichNotification(): boolean {
		return this.showOfflineIcon || !!this.title;
	}
}
